

import { motion } from 'framer-motion';

const AppLogo = () => {
  return (
    <motion.div
      className="w-60 h-60 flex items-center justify-center"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <img 
        src="/images/5329cbae-0ae5-46ae-8de9-62f4c153dad8.png" 
        alt="Mat Monster Logo" 
        className="w-60 h-60 object-contain"
      />
    </motion.div>
  );
};

export default AppLogo;
